export const JIMMY_LOVES_FOOD_ID = "495";
export const INVOICE_SURCHARGE_MULTIPLIER = 1.02;
export const INVOICE_SURCHARGE_PERCENTAGE = 0.02;

export const NETHERLANDS_COUNTRY_CODE = "NL";
export const BELGIUM_COUNTRY_CODE = "BE";
export const VAT_RATES = {
  NL: [0, 9, 21],
  BE: [0, 6, 12, 21],
};
export const PRICING_COUNTRIES = [
  { code: "NL", label: "netherlands" },
  { code: "FR", label: "france" },
  { code: "DE", label: "germany" },
  { code: "BE", label: "belgium" },
  { code: "LU", label: "luxembourg" },
];
